// Баннер скрывается до конца сессии вкладки и только на той странице, где его закрыли:
// на других страницах и в новой вкладке он снова показывается.
const STORAGE_KEY_PREFIX = "vkBannerHidden:";

const banner = document.querySelector(".vk-banner");

if (banner) {
	const storageKey = STORAGE_KEY_PREFIX + banner.dataset.vkBannerPage;

	const isHidden = () => {
		try {
			return sessionStorage.getItem(storageKey) === "true";
		} catch {
			return false;
		}
	};

	if (!isHidden()) {
		banner.classList.remove("vk-banner--hidden");
	}

	banner.querySelector(".vk-banner__close").addEventListener("click", () => {
		banner.classList.add("vk-banner--hidden");

		try {
			sessionStorage.setItem(storageKey, "true");
		} catch {
			// Хранилище недоступно — баннер скрыт до перезагрузки страницы.
		}
	});
}
